


































import {Component, Inject, Prop, Vue} from 'vue-property-decorator';
import FlexGridModel, {AggregateRow} from '@/models/FlexGridModel';

@Component
export default class FlexGridTableAggregateRow extends Vue {
    @Prop() info!: AggregateRow;
    @Inject() moduleName!: string;
    @Inject() selectable!: boolean;

    get mainData(): FlexGridModel | null {
        return this.$store.state[this.moduleName].data;
    }
    get isEditable(): number {
        return this.$store.state[this.moduleName].isEditable;
    }

    get emptyCellsCount() {
        return this.$store.getters[`${this.moduleName}/emptyCellsCount`] + Number(this.selectable);
    }

    get trStyle() {
        return {
            'background-color': `rgba(162, 93, 77, ${this.backgroundAlpha})`,
            display: this.info.show ? null : 'none',
        };
    }
    get tdStyle() {
        return {
            color: this.info.depth < 4 ? '#fff' : null,
            'background-color': `rgba(162, 93, 77, ${this.backgroundAlpha})`,
        };
    }
    get backgroundAlpha() {
        return 1 - this.info.depth * 0.1;
    }
}
